module.exports = __webpack_public_path__ + "img/supervise.bfe3811c.jpg";